import { TSteps } from 'shared/types/form';
import { TApplicationState } from 'shared/types/redux';

export const selectFormStep = (state: TApplicationState): TSteps => {
  return state.formStatus.step;
};
